export default __webpack_public_path__ + "_/images/landing-ladder/streamers/team-photo-ed44b0174c60542d690d140ea8292ebdd3c8ebd87d49eed6afcaecbecf51fb8a.svg";